import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {AbstractListService} from '../../../services/abstract-list.service';
import {ImageListEntity} from '../../../entities/image-list.entity';

/**
 * Service for the ImageListingPage
 * @class
 */
@Injectable()
export class ImageListService extends AbstractListService {
  /** @inheritdoc */
  protected enabledTypes = ['content_image'];

  /** @inheritdoc */
  protected showMineOnly: boolean = false;

  /** @inheritdoc */
  protected listType: string = 'Images';

  /** @inheritdoc */
  protected limit: number = 40;

  /** @inheritdoc */
  getList(skipLoading: boolean = false): Observable<any> {
    const formData = this.getFormData();
    this.setParams(formData);
    this.setLoadingMessage(`Getting ${this.listType}`);

    return this.callPostEndpoint('image_search/paged_list/mobile_image.item_structure/', skipLoading);
  }

  /** @inheritdoc */
  populateListEntities(objArr: any[]): ImageListEntity[] {
    const items = [];

    for (const item of objArr) {
      if (item.id) {
        items.push(new ImageListEntity(item, this.imgService));
      }
    }
    return items;
  }

  getFormData() {
    let ret = super.getFormData();
    ret = Object.assign(ret, {
      'image_search[keywords]': this.keyword,
      'image_search[limit]': this.limit,
      'image_search[offset]': this.offset,
      'image_search[sortBy]': this.sortBy,
      'skipFormView': true,
    });

    return ret;
  }
}



// WEBPACK FOOTER //
// ./src/app/list/components/image-list/services/image-list.service.ts